//#region components/select_menu/select_menu_constants.js
var e = {
	100: "d-select--xs",
	200: "d-select--sm",
	300: "",
	400: "d-select--lg",
	500: "d-select--xl",
	xs: "d-select--xs",
	sm: "d-select--sm",
	md: "",
	lg: "d-select--lg",
	xl: "d-select--xl"
}, t = {
	critical: "d-select__input--critical",
	warning: "d-select__input--warning",
	positive: "d-select__input--positive"
}, n = {
	SELECT_SIZE_MODIFIERS: e,
	SELECT_STATE_MODIFIERS: t
};
//#endregion
export { e as SELECT_SIZE_MODIFIERS, t as SELECT_STATE_MODIFIERS, n as default };

//# sourceMappingURL=select-menu-constants.js.map